import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FetchGiftAllocate } from "../../redux/actions/GiftAction";
import { DashboardLayout } from "../../Pages/dashboard/DashboardLayout";
import { useNavigate } from "react-router-dom";
import {
  FaArrowLeft,
  FaUser,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";
import { FiDownload } from "react-icons/fi";
import SearchBar from "../../Pages/Components/SearchBar";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";
import axiosInstance from "../../api/axiosInstance";
const GiftAllocate = () => {
  const dispatch = useDispatch();
  const { loading, error, gifts } = useSelector((state) => state.gift);
  const { userInfo } = useSelector((state) => state.auth);
  const [searchValue, setSearchValue] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [expandedAllocation, setExpandedAllocation] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (userInfo?.access_token) {
      dispatch(FetchGiftAllocate(userInfo.access_token));
    }
  }, [dispatch, userInfo?.access_token]);

  if (error) return <p>Error: {error}</p>;

  const allocationData = Array.isArray(gifts?.data)
    ? gifts.data
    : gifts?.data || [];

  const filteredAllocations = allocationData
    .filter((allocation) => {
      const search = searchValue.toLowerCase();
      const schemeName = allocation.qr_scheme?.toLowerCase() || "";
      const approvedBy =
        allocation.gifts?.[0]?.approved_by?.toLowerCase() || "";
      return schemeName.includes(search) || approvedBy.includes(search);
    })
    .filter((allocation) => {
      if (!startDate && !endDate) return true;

      const rawDate = allocation.created_at?.trim();
      let allocationDate;

      if (rawDate.includes("-")) {
        const parts = rawDate.split(" ")[0].split("-");
        if (parts[0].length === 4) {
          allocationDate = dayjs(rawDate);
        } else {
          const [day, month, year] = parts;
          const formattedDate = `${year}-${month}-${day}`;
          allocationDate = dayjs(formattedDate);
        }
      } else {
        allocationDate = dayjs(rawDate);
      }

      if (!allocationDate.isValid()) {
        console.warn("Parsed invalid date:", rawDate);
        return false;
      }

      const start = startDate ? dayjs(startDate).startOf("day") : null;
      const end = endDate ? dayjs(endDate).endOf("day") : null;

      if (start && allocationDate.isBefore(start)) return false;
      if (end && allocationDate.isAfter(end)) return false;

      return true;
    });

  const handleDownload = async () => {
    try {
      const response = await dispatch(
        FetchGiftAllocate(userInfo.access_token, { download: true })
      );
      const fileUrl = response?.download_url;
      if (fileUrl) {
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (err) {
      console.error("Download failed:", err);
    }
  };

  return (
    <DashboardLayout>
      <div className="mt-2 max-w-full mx-auto rounded-lg p-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <button
              onClick={() => navigate(-1)}
              className="hover:text-gray-800"
            >
              <FaArrowLeft size={20} />
            </button>
            <h2 className="text-2xl font-bold text-amber-600 ">
              Gift Allocations
            </h2>
          </div>

          <div className="flex space-x-2">
            <button
              className="flex-1 sm:flex-none bg-white flex items-center justify-center px-3 py-2 text-xs sm:text-sm font-medium text-black border border-gray-500 rounded-md hover:bg-gray-50 transition"
              onClick={() => navigate("/dashboard/allocategift")}
            >
              <span className="hidden sm:inline">Add Allocation</span>
              <span className="sm:hidden">Add</span>
            </button>
            {/* <button
              onClick={handleDownload}
              className="bg-white flex items-center px-4 py-2 text-sm font-medium text-black border border-gray-500 rounded-md transition hover:bg-gray-50"
            >
              <FiDownload className="w-4 h-4 mr-2 text-blue-500" />
              Export
            </button> */}
          </div>
        </div>

        <div className="mt-4 flex flex-wrap items-center mb-4 justify-between gap-4">
          <div className="w-full md:w-2/3 flex flex-wrap gap-4 items-center">
            <SearchBar
              value={searchValue}
              onChange={setSearchValue}
              placeholder="Search by Scheme / Approved By"
            />

            <div className="relative w-full md:w-1/3">
              <DatePicker
                selectsRange
                startDate={startDate}
                endDate={endDate}
                onChange={(update) => setDateRange(update)}
                isClearable
                placeholderText="Select date range"
                dateFormat="dd MMM yyyy"
                className="placeholder-gray-500 w-full px-4 py-2 border border-gray-500 rounded-md text-sm"
              />
            </div>
          </div>
        </div>

        {loading ? (
          <p className="font-bold text-md text-center text-gray-950 py-6">
            Loading allocations...
          </p>
        ) : filteredAllocations.length === 0 ? (
          <p className="font-bold text-md text-center text-gray-950 py-6">
            No allocations found
          </p>
        ) : (
          <div className="overflow-x-auto rounded-lg border border-gray-300">
            <table className="w-full bg-white">
              <thead className="bg-gray-100 border-b border-gray-300">
                <tr>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                    Scheme Name
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                    Gift Count
                  </th>

                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                    Approved By
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                    Created Date
                  </th>
                  <th className="px-4 py-3 text-center text-sm font-semibold text-gray-700">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredAllocations.map((allocation) => (
                  <React.Fragment key={allocation.qr_scheme}>
                    <tr className="hover:bg-blue-50 border-b border-gray-300">
                      <td className="px-4 py-4 text-sm text-gray-900 font-medium">
                        {allocation.qr_scheme}
                      </td>
                      <td className="px-4 py-4 text-sm text-gray-900">
                        <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-blue-100 text-blue-800">
                          {allocation.gift_count}
                        </span>
                      </td>

                      <td className="px-4 py-4 text-sm text-gray-900">
                        {allocation.gifts?.[0]?.approved_by || "-"}
                      </td>
                      <td className="px-4 py-4 text-sm text-gray-900">
                        {dayjs(allocation.created_at).format("DD MMM YYYY")}
                      </td>
                      <td className="px-4 py-4 text-center">
                        <button
                          onClick={() =>
                            setExpandedAllocation(
                              expandedAllocation === allocation.qr_scheme
                                ? null
                                : allocation.qr_scheme
                            )
                          }
                          className="inline-flex items-center px-4 py-2 text-sm font-medium bg-amber-500 text-white  rounded-md hover:bg-amber-600 text-white transition"
                        >
                          {expandedAllocation === allocation.qr_scheme ? (
                            <>
                              <FaChevronUp className="mr-2" size={14} />
                              Hide Details
                            </>
                          ) : (
                            <>
                              <FaChevronDown className="mr-2" size={14} />
                              More
                            </>
                          )}
                        </button>
                      </td>
                    </tr>

                    {expandedAllocation === allocation.qr_scheme && (
                      <tr>
                        <td colSpan="5" className="px-4 py-4 bg-gray-50">
                          <div className="space-y-4">
                            <h4 className="font-semibold text-gray-900">
                              Gifts in this scheme (
                              {allocation.gifts?.length || 0})
                            </h4>
                            {allocation.gifts && allocation.gifts.length > 0 ? (
                              <div className="overflow-x-auto border border-gray-300 rounded-lg">
                                <table className="w-full bg-white text-sm">
                                  <thead className="bg-gray-200 border-b border-gray-300">
                                    <tr>
                                      <th className="px-4 py-2 text-left font-semibold text-gray-700">
                                        Gift Image
                                      </th>
                                      <th className="px-4 py-2 text-left font-semibold text-gray-700">
                                        Gift Name
                                      </th>

                                      <th className="px-4 py-2 text-left font-semibold text-gray-700">
                                        QR Count
                                      </th>
                                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                                        Bumper Offer Available
                                      </th>
                                      <th className="px-4 py-2 text-left font-semibold text-gray-700">
                                        Status
                                      </th>
                                      <th className="px-4 py-2 text-left font-semibold text-gray-700">
                                        Created Date
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {allocation.gifts.map((gift) => (
                                      <tr
                                        key={gift.allotment_id}
                                        className="border-b border-gray-300 hover:bg-gray-100"
                                      >
                                        <td className="px-4 py-3">
                                          {gift.gift_image ? (
                                            <img
                                              src={`${axiosInstance.defaults.baseURL}${gift.gift_image}`}
                                              alt={gift.gift_name}
                                              className="w-12 h-12 rounded object-cover border border-gray-300"
                                              onError={(e) => {
                                                e.target.src =
                                                  'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48"><rect width="48" height="48" fill="%23ddd"/><text x="50%" y="50%" text-anchor="middle" dy=".3em" fill="%23999" font-size="10">No Image</text></svg>';
                                              }}
                                            />
                                          ) : (
                                            <div className="w-12 h-12 bg-gray-200 rounded flex items-center justify-center">
                                              <FaGift className="text-gray-400" />
                                            </div>
                                          )}
                                        </td>
                                        <td className="px-4 py-3 text-gray-900 font-medium">
                                          {gift.gift_name}
                                        </td>

                                        <td className="px-4 py-3 text-gray-900">
                                          <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-purple-100 text-purple-800">
                                            {gift.qr_count}
                                          </span>
                                        </td>
                                        <td className="px-4 py-4 text-sm text-gray-900">
                                          {gift.is_additional_gift ? (
                                            <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-amber-100 text-amber-800">
                                              Yes
                                            </span>
                                          ) : (
                                            <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-red-100 text-red-800">
                                              No
                                            </span>
                                          )}
                                        </td>
                                        <td className="px-4 py-3">
                                          <span
                                            className={`px-3 py-1 rounded text-xs font-semibold ${
                                              gift.is_live
                                                ? "bg-green-100 text-green-800"
                                                : "bg-red-100 text-red-800"
                                            }`}
                                          >
                                            {gift.is_live ? "Live" : "Inactive"}
                                          </span>
                                        </td>
                                        <td className="px-4 py-3 text-gray-900">
                                          {dayjs(gift.created_at).format(
                                            "DD MMM YYYY"
                                          )}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            ) : (
                              <p className="text-gray-500 text-sm">
                                No gifts found for this scheme.
                              </p>
                            )}
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default GiftAllocate;
